import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';

import { Datastore } from '../datastore/datastore';
import { OnlineOfflineStatusType } from '../datastore/online-offline/online-offline.model';
import { User } from '../datastore/user/user.model';

@Component({
  selector: 'fl-online-status',
  template: `
    <fl-online-indicator flLayoutFlex="noshrink"
      [relatedUser]="user.displayName"
      [status]="(onlineOfflineObservable | async)">
    </fl-online-indicator>
  `,
})
export class OnlineStatusComponent implements OnInit, OnChanges, OnDestroy {
  @Input() user: User;
  onlineOfflineObservable: Observable<'online' | 'offline'>;
  private userId: BehaviorSubject<string>;

  constructor(private datastore: Datastore) {}

  ngOnInit() {
    this.onlineOfflineObservable = this.datastore
      .object('onlineOffline', this.userId)
      .map(
        entry =>
          entry.status === OnlineOfflineStatusType.online
            ? 'online'
            : 'offline',
      );
  }

  ngOnChanges(changes: SimpleChanges) {
    // Note ngOnChanges is called BEFORE ngOnInit is.
    // This works as long as the user object is replaced not mutated.
    if (!this.userId) {
      this.userId = new BehaviorSubject(String(this.user.id));
    } else {
      this.userId.next(String(changes.user.currentValue.id));
    }
  }

  ngOnDestroy() {
    this.userId.complete();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/online-status/online-status.component.ts